const storageKey = (workspaceId: number): string => `onboarding-return-home-hint-dismissed-${workspaceId}`;

/** Whether the hint was dismissed for this workspace. Storage errors fail soft to "not dismissed". */
export function readReturnHomeHintDismissed(workspaceId: number): boolean {
  try {
    return localStorage.getItem(storageKey(workspaceId)) === 'true';
  } catch {
    return false;
  }
}

export function persistReturnHomeHintDismissed(workspaceId: number): void {
  try {
    localStorage.setItem(storageKey(workspaceId), 'true');
  } catch {
    // Storage unavailable: the dismissal still applies for this visit.
  }
}
